import React from "react";
import { Button, Typography } from "@material-ui/core";
import { Row, Col } from "react-bootstrap";
import { withRouter } from "react-router";
import { get, post } from "../../../api/axios";
import { List } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import EditIcon from "@material-ui/icons/Edit";
import "./style.css";
import { Delete } from "@material-ui/icons";
import { openAlert } from "simple-react-alert";
const NegocioOpciones = props => {
    const [cadetes, setCadetes] = React.useState([]);
    const [cadetesInd, setCadetesInd] = React.useState([]);

    const getCadetes = () => {
        get("/admin-negocios/cadetes").then(response => {
            setCadetes(response.data)
        });
        get("/admin-negocios/cadetes/independientes").then(response => {
            setCadetesInd(response.data)
        });
    }
    React.useEffect(() => {
        getCadetes();
    }, []);

    const deslinkear = (id) => {
        post("/admin-negocios/cadetes/independientes/desasociar/" + id, {}).then(response => {
            openAlert({ message: "Eliminado exitoso", type: "success" });
            getCadetes();
        });

    }
    return (
        <>
            <Row
                xs={{ span: 12, offset: 2 }}
                className="justify-content-md-center rowContainer"
            >
                <Col xs={8}>
                    <Button
                        size="large"
                        variant="contained"
                        className="ml-2"
                        onClick={() =>
                            props.history.push(props.match.url + "/adminnegocio/nuevo")
                        }
                    >
                        Agregar Cadete
                    </Button>
                    <Button
                        size="large"
                        variant="contained"
                        className="ml-2"
                        onClick={() =>
                            props.history.push(props.match.url + "/adminnegocio/disponibles")
                        }
                    >
                        Cadetes disponibles
                    </Button>
                    <Button
                        size="large"
                        variant="contained"
                        className="ml-2"
                        onClick={() =>
                            props.history.push(props.match.url + "/adminnegocio/sincronizar")
                        }
                    >
                        Sincronizar cadete
                    </Button>
                </Col>
                {cadetes && cadetes.map && cadetes.map((cadete, key) => {
                    return <Col xs={8}>
                        <List
                            component="nav"
                            aria-label="main mailbox folders"
                            style={{ maxHeight: "400px", overflow: "auto" }}
                        >
                            <ListItem
                                button
                                onClick={() => {
                                    props.history.push({
                                        pathname:
                                            props.match.url +
                                            "/adminnegocio/editar/" +
                                            cadete.id
                                    });
                                }}
                                key={key}
                            >
                                <ListItemText primary={cadete.nombre + ' ' + cadete.apellido} />
                                <ListItemIcon>
                                    <EditIcon />
                                </ListItemIcon>
                            </ListItem>
                        </List>
                    </Col>
                })}
                {cadetesInd && cadetesInd.map && cadetesInd.map((cadete, key) => {
                    return <Col xs={8}>
                        <List
                            component="nav"
                            aria-label="main mailbox folders"
                            style={{ maxHeight: "400px", overflow: "auto" }}
                        >
                            <ListItem
                                button
                                key={key}
                            >
                                <ListItemText primary={cadete.nombre + ' ' + cadete.apellido + ' *INDEPENDIENTE*'} />
                                <ListItemIcon>
                                    <Delete onClick={() => {
                                        deslinkear(cadete.id)
                                    }} />
                                </ListItemIcon>
                            </ListItem>
                        </List>
                    </Col>
                })}
            </Row>
        </>
    );
};

export default withRouter(NegocioOpciones);
